import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { GetAddonsService } from '../../../services/get-addons/get-addons.service';
import { AddonResponseInterface } from '../../../interfaces/get-addons.interface'; // Mantén la importación de la interfaz
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../services/general/loading.service';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';
import { ErrorAlertComponent } from "../../shared/error-alert/error-alert.component";
import { Router } from '@angular/router';
import { ResultsModalComponent, ResultField } from '../../shared/results-modal/results-modal.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
  selector: 'app-get-addons',
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, ResultsModalComponent, PageHeaderComponent],
  templateUrl: './get-addons.component.html',
  styleUrls: ['./get-addons.component.css']
})
export class GetAddonsComponent implements OnInit {
  addons: AddonResponseInterface[] = [];
  token: string = '';
  nitInput: string = '';
  showAlertError: boolean = false
  errorMessage = ''
  showResultsModal: boolean = false;
  resultsData: ResultField[] = [];
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Consultar Complemento',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private getAddonsService: GetAddonsService,
    private _loadingService: LoadingService,
    private _logsService: LogTackingService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') ?? '';
  }

  onSubmit(form: NgForm) {
    this._loadingService.setLoading(true)
    this.getAddonsService.getAddons(this.token, this.nitInput).subscribe({
      next: (response: { cliente: string, response: any }) => {
        this._loadingService.setLoading(false)
        if (Array.isArray(response.response)) {
          const addons: AddonResponseInterface[] = response.response.map(addon => ({
            cliente: response.cliente,
            response: addon
          }));
          this.addons = this.addons.concat(addons);
          
          // Preparar datos para el modal
          const complementoValue = Array.isArray(addons[0].response) 
            ? addons[0].response.join(', ') 
            : String(addons[0].response);
          
          this.resultsData = [
            { label: 'NIT', value: response.cliente },
            { label: 'COMPLEMENTO', value: complementoValue }
          ];
          this.showResultsModal = true;
          
          this.log_info.details = `Success: Usuario obtuvo con exito complemento de la cuenta ${this.nitInput}`
          this.createTrackingLog()
        } else {
          this.errorMessage = response.response
          this.showErrorComponent(form)
        }
      },
      error: (err) => {
        this.showErrorComponent(form)
      }
    });
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

  cancel(form: NgForm) {
    this.addons = [];
    this.nitInput = '';
    form.resetForm();
  }

  closeResultsModal() {
    this.showResultsModal = false;
  }

  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.log_info.details = `No se pudieron relacionar los datos para el NIT ${this.nitInput}`
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }
}
